import { Territorio } from './../../../shared/models/territorio.model';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/services/base/base.service";
import { UtilService } from "src/app/services/util.service";


@Injectable({
  providedIn: 'root'
})
export class TerritorioService extends BaseService<any>{
  serviceName: string = 'v2/territorios';

  constructor(
    protected http: HttpClient,
    protected utilService: UtilService
  ) {
    super(http, utilService);
  }

  deletarTerritorio(idTerritorio: number) {
    return this.http.delete(this.urlApi + this.serviceName + '/deletarTerritorio' + this.utilService.paramsToQueryString({ idTerritorio: idTerritorio }));
  }

  listarPublic(params: any) {
    return this.http.post<Territorio[]>(this.urlApi + "public/" + this.serviceName, params);
  }
}
